<template>
  <div id="app">
    <Header />
    <Content />
  </div>
</template>

<script>
import qs from 'qs'
import { mapState, mapMutations } from 'vuex'
import Header from './components/Header.vue'
import Content from './components/Content.vue'

export default {
  components: {
    Header,
    Content
  },
  computed: {
    ...mapState({
      shirtsOverallItems: state => state.shirts.data.items.overall,
      shirtsBodyMainItems: state => state.shirts.data.items.body_main,
      shirtsBodySideItems: state => state.shirts.data.items.body_side,
      shirtsCollarItems: state => state.shirts.data.items.collar,
      shirtsArmShoulderPartItems: state => state.shirts.data.items.arm_shoulder_part,
      shirtsArmArmPartItems: state => state.shirts.data.items.arm_arm_part,
      shirtsArmSleevePartItems: state => state.shirts.data.items.arm_sleeve_part,
      shirtsArmSleeveLineItems: state => state.shirts.data.items.arm_sleeve_line,
      pantsItems: state => state.pants.data.items,
      capVisorFormItems: state => state.cap.data.items.visor_form,
      capVisorLineItems: state => state.cap.data.items.visor_line,
      capMarkItems: state => state.cap.data.items.mark,
      emblemItems: state => state.emblem.data.items,
      markChestItems: state => state.mark.data.items.both_sides.concat(state.mark.data.items.one_side),
      markChestNumberItems: state => state.mark.data.items.chest_number,
      markBackItems: state => state.mark.data.items.back_name,
      markBackNumberItems: state => state.mark.data.items.back_number,
      markSleeveItems: state => state.mark.data.items.japanese.concat(state.mark.data.items.english),
    }),
    queries() {
      return qs.parse(location.search.substr(1))
    },
  },
  created() {
    // シャツ -> メインアイテム
    if (this.queries.overallItem) {
      const current = this.shirtsOverallItems.find(item => item.id == this.queries.overallItem)
      this.changeOverallItem(current)
    }
    // シャツ -> メインアイテム -> 単色の色
    if (this.queries.overallItemSingleColor) {
      this.changeOverallItemSingleColor(this.queries.overallItemSingleColor)
    }
    // シャツ -> メインアイテム -> グラデーションの開始色
    if (this.queries.overallItemGradationStartColor) {
      this.changeOverallItemGradationStartColor(this.queries.overallItemGradationStartColor)
    }
    // シャツ -> メインアイテム -> グラデーションの終了色
    if (this.queries.overallItemGradationEndColor) {
      this.changeOverallItemGradationEndColor(this.queries.overallItemGradationEndColor)
    }
    // シャツ -> メインアイテム -> ストライプの色
    if (this.queries.overallItemStripeColor) {
      this.changeOverallItemStripeColor(this.queries.overallItemStripeColor)
    }
    // シャツ -> メインアイテム -> 柄
    if (this.queries.overallItemTexture) {
      this.changeOverallItemTexture(this.queries.overallItemTexture)
    }
    // シャツ -> 胴 -> 胴
    if (this.queries.bodyMainItem) {
      const current = this.shirtsBodyMainItems.find(item => item.id == this.queries.bodyMainItem)
      this.changeBodyMainItem(current)
    }
    // シャツ -> 胴 -> 胴 -> 色
    if (this.queries.bodyMainItemColor) {
      this.changeBodyMainItemColor(this.queries.bodyMainItemColor)
    }
    // シャツ -> 胴 -> 胴 -> 柄
    if (this.queries.bodyMainItemTexture) {
      this.changeBodyMainItemTexture(this.queries.bodyMainItemTexture)
    }
    // シャツ -> 胴 -> 脇
    if (this.queries.bodySideItem) {
      const current = this.shirtsBodySideItems.find(item => item.id == this.queries.bodySideItem)
      this.changeBodySideItem(current)
    }
    // シャツ -> 胴 -> 脇 -> 色
    if (this.queries.bodySideItemColor) {
      this.changeBodySideItemColor(this.queries.bodySideItemColor)
    }
    // シャツ -> 胴 -> 脇 -> 色2
    if (this.queries.bodySideItemColor2) {
      this.changeBodySideItemColor2(this.queries.bodySideItemColor2)
    }
    // シャツ -> 胴 -> 脇 -> 柄
    if (this.queries.bodySideItemTexture) {
      this.changeBodySideItemTexture(this.queries.bodySideItemTexture)
    }
    // シャツ -> 襟ライン
    if (this.queries.collarItem) {
      const current = this.shirtsCollarItems.find(item => item.id == this.queries.collarItem)
      this.changeCollarItem(current)
    }
    // シャツ -> 襟ライン -> 色
    if (this.queries.collarItemColor) {
      this.changeCollarItemColor(this.queries.collarItemColor)
    }
    // シャツ -> 襟ライン -> 色2
    if (this.queries.collarItemColor2) {
      this.changeCollarItemColor2(this.queries.collarItemColor2)
    }
    // シャツ -> 襟ライン -> 色3
    if (this.queries.collarItemColor3) {
      this.changeCollarItemColor3(this.queries.collarItemColor3)
    }
    // シャツ -> 腕 -> 肩パーツ
    if (this.queries.armShoulderPartItem) {
      const current = this.shirtsArmShoulderPartItems.find(item => item.id == this.queries.armShoulderPartItem)
      this.changeArmShoulderPartItem(current)
    }
    // シャツ -> 腕 -> 肩パーツ -> 色
    if (this.queries.armShoulderPartItemColor) {
      this.changeArmShoulderPartItemColor(this.queries.armShoulderPartItemColor)
    }
    // シャツ -> 腕 -> 腕パーツ
    if (this.queries.armArmPartItem) {
      const current = this.shirtsArmArmPartItems.find(item => item.id == this.queries.armArmPartItem)
      this.changeArmArmPartItem(current)
    }
    // シャツ -> 腕 -> 腕パーツ -> 色
    if (this.queries.armArmPartItemColor) {
      this.changeArmArmPartItemColor(this.queries.armArmPartItemColor)
    }
    // シャツ -> 腕 -> 腕パーツ -> 色2
    if (this.queries.armArmPartItemColor2) {
      this.changeArmArmPartItemColor2(this.queries.armArmPartItemColor2)
    }
    // シャツ -> 腕 -> 袖パーツ
    if (this.queries.armSleevePartItem) {
      const current = this.shirtsArmSleevePartItems.find(item => item.id == this.queries.armSleevePartItem)
      this.changeArmSleevePartItem(current)
    }
    // シャツ -> 腕 -> 袖パーツ -> 色
    if (this.queries.armSleevePartItemColor) {
      this.changeArmSleevePartItemColor(this.queries.armSleevePartItemColor)
    }
    // シャツ -> 腕 -> 袖パーツ -> 色2
    if (this.queries.armSleevePartItemColor2) {
      this.changeArmSleevePartItemColor2(this.queries.armSleevePartItemColor2)
    }
    // シャツ -> 腕 -> 袖ライン
    if (this.queries.armSleeveLineItem) {
      const current = this.shirtsArmSleeveLineItems.find(item => item.id == this.queries.armSleeveLineItem)
      this.changeArmSleeveLineItem(current)
    }
    // シャツ -> 腕 -> 袖ライン -> 色
    if (this.queries.armSleeveLineItemColor) {
      this.changeArmSleeveLineItemColor(this.queries.armSleeveLineItemColor)
    }
    // シャツ -> 腕 -> 袖ライン -> 色2
    if (this.queries.armSleeveLineItemColor2) {
      this.changeArmSleeveLineItemColor2(this.queries.armSleeveLineItemColor2)
    }
    // シャツ -> 腕 -> 袖ライン -> 色3
    if (this.queries.armSleeveLineItemColor3) {
      this.changeArmSleeveLineItemColor3(this.queries.armSleeveLineItemColor3)
    }




    // パンツ -> ベース
    if (this.queries.baseItem) {
      const current = this.pantsItems.find(item => item.id == this.queries.baseItem)
      this.changeBaseItem(current)
    }
    // パンツ -> 装飾
    if (this.queries.decorateItem) {
      const current = this.pantsItems.find(item => item.id == this.queries.decorateItem)
      this.changeDecorateItem(current)
    }
    // パンツ -> 装飾 -> 色
    if (this.queries.decorateItemColor) {
      this.changeDecorateItemColor(this.queries.decorateItemColor)
    }
    // キャップ -> バイザー -> 形
    if (this.queries.visorFormItem) {
      const current = this.capVisorFormItems.find(item => item.id == this.queries.visorFormItem)
      this.changeVisorFormItem(current)
    }
    // キャップ -> バイザー -> 形 -> 色
    if (this.queries.visorFormItemColor) {
      this.changeVisorFormItemColor(this.queries.visorFormItemColor)
    }
    // キャップ -> バイザー -> 形 -> 柄
    if (this.queries.visorFormItemTexture) {
      this.changeVisorFormItemTexture(this.queries.visorFormItemTexture)
    }
    // キャップ -> バイザ -> バイザーライン
    if (this.queries.visorLineItem) {
      const current = this.capVisorLineItems.find(item => item.id == this.queries.visorLineItem)
      this.changeVisorLineItem(current)
    }
    // キャップ -> バイザ -> バイザーライン -> 色
    if (this.queries.visorLineItemColor) {
      this.changeVisorLineItemColor(this.queries.visorLineItemColor)
    }
    // キャップ -> クラウン -> 正面 -> 色
    if (this.queries.crownFrontColor) {
      this.changeCrownFrontColor(this.queries.crownFrontColor)
    }
    // キャップ -> クラウン -> サイドバック -> 色
    if (this.queries.crownBackColor) {
      this.changeCrownBackColor(this.queries.crownBackColor)
    }
    // キャップ -> クラウン -> 穴がかり -> 色
    if (this.queries.crownHoleColor) {
      this.changeCrownHoleColor(this.queries.crownHoleColor)
    }
    // キャップ -> クラウン -> 天ボタン -> 色
    if (this.queries.crownButtonColor) {
      this.changeCrownButtonColor(this.queries.crownButtonColor)
    }
    // キャップ -> マーク
    if (this.queries.markItem) {
      const current = this.capMarkItems.find(item => item.id == this.queries.markItem)
      this.changeMarkItem(current)
    }
    // キャップ -> マーク -> 色
    if (this.queries.markItemColor1) {
      this.changeMarkItemColor1(this.queries.markItemColor1)
    }
    // キャップ -> マーク -> 色2
    if (this.queries.markItemColor2) {
      this.changeMarkItemColor2(this.queries.markItemColor2)
    }
    // キャップ -> マーク -> 色3
    if (this.queries.markItemColor3) {
      this.changeMarkItemColor3(this.queries.markItemColor3)
    }
    // エンブレム
    if (this.queries.emblemItem) {
      const current = this.emblemItems.find(item => item.id == this.queries.emblemItem)
      this.changeEmblemItem(current)
    }
    // マーク -> 胸マーク -> マーク
    if (this.queries.chestItem) {
      const current = this.markChestItems.find(item => item.id == this.queries.chestItem)
      this.changeChestItem(current)
    }
    // マーク -> 胸マーク -> マーク -> 色
    if (this.queries.chestItemColor1) {
      this.changeChestItemColor1(this.queries.chestItemColor1)
    }
    // マーク -> 胸マーク -> マーク -> 色2
    if (this.queries.chestItemColor2) {
      this.changeChestItemColor2(this.queries.chestItemColor2)
    }
    // マーク -> 胸マーク -> マーク -> 色3
    if (this.queries.chestItemColor3) {
      this.changeChestItemColor3(this.queries.chestItemColor3)
    }
    // マーク -> 胸マーク -> 胸番号
    if (this.queries.chestNumberItem) {
      const current = this.markChestNumberItems.find(item => item.id == this.queries.chestNumberItem)
      this.changeChestNumberItem(current)
    }
    // マーク -> 胸マーク -> 胸番号 -> 色
    if (this.queries.chestNumberItemColor1) {
      this.changeChestNumberItemColor1(this.queries.chestNumberItemColor1)
    }
    // マーク -> 背面 -> 背ネーム
    if (this.queries.backItem) {
      const current = this.markBackItems.find(item => item.id == this.queries.backItem)
      this.changeBackItem(current)
    }
    // マーク -> 背面 -> 背ネーム -> 色
    if (this.queries.backItemColor1) {
      this.changeBackItemColor1(this.queries.backItemColor1)
    }
    // マーク -> 背面 -> 背ネーム -> 色2
    if (this.queries.backItemColor2) {
      this.changeBackItemColor2(this.queries.backItemColor2)
    }
    // マーク -> 背面 -> 番号
    if (this.queries.backNumberItem) {
      const current = this.markBackNumberItems.find(item => item.id == this.queries.backNumberItem)
      this.changeBackNumberItem(current)
    }
    // マーク -> 背面 -> 番号 -> 色
    if (this.queries.backNumberItemColor1) {
      this.changeBackNumberItemColor1(this.queries.backNumberItemColor1)
    }
    // マーク -> 袖マーク
    if (this.queries.sleeveItem) {
      const current = this.markSleeveItems.find(item => item.id == this.queries.sleeveItem)
      this.changeSleeveItem(current)
    }
    // マーク -> 袖マーク -> 色
    if (this.queries.sleeveItemColor1) {
      this.changeSleeveItemColor1(this.queries.sleeveItemColor1)
    }
  },
  methods: {
    ...mapMutations({
      changeOverallItem: 'shirts/changeOverallItem',
      changeOverallItemSingleColor: 'shirts/changeOverallItemSingleColor',
      changeOverallItemGradationStartColor: 'shirts/changeOverallItemGradationStartColor',
      changeOverallItemGradationEndColor: 'shirts/changeOverallItemGradationEndColor',
      changeOverallItemStripeColor: 'shirts/changeOverallItemStripeColor',
      changeOverallItemTexture: 'shirts/changeOverallItemTexture',
      changeBodyMainItem: 'shirts/changeBodyMainItem',
      changeBodyMainItemColor: 'shirts/changeBodyMainItemColor',
      changeBodyMainItemTexture: 'shirts/changeBodyMainItemTexture',
      changeBodySideItem: 'shirts/changeBodySideItem',
      changeBodySideItemColor: 'shirts/changeBodySideItemColor',
      changeBodySideItemColor2: 'shirts/changeBodySideItemColor2',
      changeBodySideItemTexture: 'shirts/changeBodySideItemTexture',
      changeCollarItem: 'shirts/changeCollarItem',
      changeCollarItemColor: 'shirts/changeCollarItemColor',
      changeCollarItemColor2: 'shirts/changeCollarItemColor2',
      changeCollarItemColor3: 'shirts/changeCollarItemColor3',
      changeArmShoulderPartItem: 'shirts/changeArmShoulderPartItem',
      changeArmShoulderPartItemColor: 'shirts/changeArmShoulderPartItemColor',
      changeArmArmPartItem: 'shirts/changeArmArmPartItem',
      changeArmArmPartItemColor: 'shirts/changeArmArmPartItemColor',
      changeArmArmPartItemColor2: 'shirts/changeArmArmPartItemColor2',
      changeArmSleevePartItem: 'shirts/changeArmSleevePartItem',
      changeArmSleevePartItemColor: 'shirts/changeArmSleevePartItemColor',
      changeArmSleevePartItemColor2: 'shirts/changeArmSleevePartItemColor2',
      changeArmSleeveLineItem: 'shirts/changeArmSleeveLineItem',
      changeArmSleeveLineItemColor: 'shirts/changeArmSleeveLineItemColor',
      changeArmSleeveLineItemColor2: 'shirts/changeArmSleeveLineItemColor2',
      changeArmSleeveLineItemColor3: 'shirts/changeArmSleeveLineItemColor3',
      changeBaseItem: 'pants/changeBaseItem',
      changeDecorateItem: 'pants/changeDecorateItem',
      changeDecorateItemColor: 'pants/changeDecorateItemColor',
      changeVisorFormItem: 'cap/changeVisorFormItem',
      changeVisorFormItemColor: 'cap/changeVisorFormItemColor',
      changeVisorFormItemTexture: 'cap/changeVisorFormItemTexture',
      changeVisorLineItemColor: 'cap/changeVisorLineItemColor',
      changeCrownFrontColor: 'cap/changeCrownFrontColor',
      changeCrownBackColor: 'cap/changeCrownBackColor',
      changeCrownHoleColor: 'cap/changeCrownHoleColor',
      changeCrownButtonColor: 'cap/changeCrownButtonColor',
      changeMarkItem: 'cap/changeMarkItem',
      changeMarkItemColor1: 'cap/changeMarkItemColor1',
      changeMarkItemColor2: 'cap/changeMarkItemColor2',
      changeMarkItemColor3: 'cap/changeMarkItemColor3',
      changeEmblemItem: 'emblem/changeItem',
      changeChestItem: 'mark/changeChestItem',
      changeChestItemColor1: 'mark/changeChestItemColor1',
      changeChestItemColor2: 'mark/changeChestItemColor2',
      changeChestItemColor3: 'mark/changeChestItemColor3',
      changeChestNumberItem: 'mark/changeChestNumberItem',
      changeChestNumberItemColor1: 'mark/changeChestNumberItemColor1',
      changeBackItem: 'mark/changeBackItem',
      changeBackItemColor1: 'mark/changeBackItemColor1',
      changeBackItemColor2: 'mark/changeBackItemColor2',
      changeBackNumberItem: 'mark/changeBackNumberItem',
      changeBackNumberItemColor1: 'mark/changeBackNumberItemColor1',
      changeSleeveItem: 'mark/changeSleeveItem',
      changeSleeveItemColor1: 'mark/changeSleeveItemColor1',
    })
  }
}
</script>

<style lang="scss">
html {
  box-sizing: border-box;
  -webkit-text-size-adjust: 100%;
  word-break: normal;
  -moz-tab-size: 4;
  tab-size: 4;
}
*,
::before,
::after {
  background-repeat: no-repeat;
  box-sizing: inherit;
}
::before,
::after {
  text-decoration: inherit;
  vertical-align: inherit;
}
* {
  padding: 0;
  margin: 0;
}
hr {
  overflow: visible; /* Show the overflow in Edge and IE */
  height: 0; /* Add the correct box sizing in Firefox */
}
details,
main {
  display: block; /* Render the `main` element consistently in IE. */
}
summary {
  display: list-item; /* Add the correct display in all browsers */
}
small {
  font-size: 80%; /* Set font-size to 80% in `small` elements */
}
[hidden] {
  display: none; /* Add the correct display in IE */
}
abbr[title] {
  border-bottom: none; /* Remove the bottom border in Chrome 57 */
  /* Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari */
  text-decoration: underline;
  text-decoration: underline dotted;
}
a {
  background-color: transparent; /* Remove the gray background on active links in IE 10 */
}
a:active,
a:hover {
  outline-width: 0; /* Remove the outline when hovering in all browsers */
}
code,
kbd,
pre,
samp {
  font-family: monospace, monospace; /* Specify the font family of code elements */
}
pre {
  font-size: 1em; /* Correct the odd `em` font sizing in all browsers */
}
b,
strong {
  font-weight: bolder; /* Add the correct font weight in Chrome, Edge, and Safari */
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
input {
  border-radius: 0;
}
[disabled] {
  cursor: default;
}
[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto; /* Correct the cursor style of increment and decrement buttons in Chrome */
}
[type="search"] {
  -webkit-appearance: textfield; /* Correct the odd appearance in Chrome and Safari */
  outline-offset: -2px; /* Correct the outline style in Safari */
}
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; /* Remove the inner padding in Chrome and Safari on macOS */
}
textarea {
  overflow: auto; /* Internet Explorer 11+ */
  resize: vertical; /* Specify textarea resizability */
}
optgroup {
  font-weight: bold; /* Restore the font weight unset by the previous rule */
}
button {
  overflow: visible; /* Address `overflow` set to `hidden` in IE 8/9/10/11 */
}
button,
select {
  text-transform: none; /* Firefox 40+, Internet Explorer 11- */
}
/* Apply cursor pointer to button elements */
button,
[type="button"],
[type="reset"],
[type="submit"],
[role="button"] {
  cursor: pointer;
  color: inherit;
}
/* Remove inner padding and border in Firefox 4+ */
button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
/* Replace focus style removed in the border reset above */
button:-moz-focusring,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  outline: 1px dotted ButtonText;
}
button,
html [type="button"], /* Prevent a WebKit bug where (2) destroys native `audio` and `video`controls in Android 4 */
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS */
}
/* Remove the default button styling in all browsers */
button,
input,
select,
textarea {
  background-color: transparent;
  border-style: none;
}
/* Style select like a standard input */
select {
  -moz-appearance: none; /* Firefox 36+ */
  -webkit-appearance: none; /* Chrome 41+ */
}
select::-ms-expand {
  display: none; /* Internet Explorer 11+ */
}
select::-ms-value {
  color: currentColor; /* Internet Explorer 11+ */
}
legend {
  border: 0; /* Correct `color` not being inherited in IE 8/9/10/11 */
  color: inherit; /* Correct the color inheritance from `fieldset` elements in IE */
  display: table; /* Correct the text wrapping in Edge and IE */
  max-width: 100%; /* Correct the text wrapping in Edge and IE */
  white-space: normal; /* Correct the text wrapping in Edge and IE */
  max-width: 100%; /* Correct the text wrapping in Edge 18- and IE */
}
::-webkit-file-upload-button {
  /* Correct the inability to style clickable types in iOS and Safari */
  -webkit-appearance: button;
  color: inherit;
  font: inherit; /* Change font properties to `inherit` in Chrome and Safari */
}
img {
  border-style: none; /* Remove border when inside `a` element in IE 8/9/10 */
}
/* Add the correct vertical alignment in Chrome, Firefox, and Opera */
progress {
  vertical-align: baseline;
}
svg:not([fill]) {
  fill: currentColor;
}
/* Hide content from screens but not screenreaders */
@media screen {
  [hidden~="screen"] {
    display: inherit;
  }
  [hidden~="screen"]:not(:active):not(:focus):not(:target) {
    position: absolute !important;
    clip: rect(0 0 0 0) !important;
  }
}
/* Specify the progress cursor of updating elements */
[aria-busy="true"] {
  cursor: progress;
}
/* Specify the pointer cursor of trigger elements */
[aria-controls] {
  cursor: pointer;
}
/* Specify the unstyled cursor of disabled, not-editable, or otherwise inoperable elements */
[aria-disabled] {
  cursor: default;
}

/**
 * Setting
 */
@function vw($num, $width: 375) {
  @return (1vw * $num / $width * 100);
}

/**
 * Element
 */
* {
  font-family: source-han-sans-japanese, sans-serif;
}
html {
  touch-action: manipulation;
}
ul, ol, li {
  list-style: none;
}
svg {
  width: 100%;
  height: auto;
}
button {
  outline: none;
}

#app {
  @media screen and (min-width: 768px){
      display: flex;
      min-height: 100vh;
      flex-direction: column;
  }
}

/**
 * Header
 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: vw(14) vw(20);
  background: #1e5799;
  background: linear-gradient(to right, #1e5799 0%,#2d7fb4 100%);
  &__logo {
    svg {
      width: vw(66);
    }
  }
  &__link {
    display: flex;
    align-items: center;
    li {
      + li {
        margin-left: vw(30);
      }
    }
    a {
      display: block;
      color: #fff;
      font-weight: bold;
      font-size: vw(10);
      text-align: center;
      text-decoration: none;
    }
    svg {
      display: block;
      width: auto;
      height: vw(26);
      margin: 0 auto vw(8);
    }
  }
  @media screen and (min-width: 768px){
    padding: 14px 20px;
    &__logo {
      svg {
        width: 66px;
      }
    }
    &__link {
      li {
        + li {
          margin-left: 30px;
        }
      }
      a {
        font-size: 10px;
      }
      svg {
        height: 26px;
        margin-bottom: 8px;
      }
    }
  }
}

/**
 * Content
 */
.content {
  @media screen and (min-width: 768px){
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 110px 30px;
    background-color: rgba(#000, .4);
    &__wrapper {
      width: 100%;
      max-width: 802px;
      border-radius: 20px;
      box-shadow: 0 0 10px rgba(#000, .15);
      background-color: #fff;
    }
    &__inner {
      display: flex;
      flex-wrap: wrap;
    }
    &__left {
      flex-basis: 50%;
      max-width: 50%;
    }
    &__right {
      flex-basis: 50%;
      max-width: 50%;
    }
    &__bottom {
      flex-basis: 100%;
    }
  }
}



/**
 * Tab
 */
.tab {
  margin-bottom: vw(24);
  &__items {
    display: flex;
    padding: 0 vw(2);
  }
  &__item {
    flex: 0 0 20%;
    max-width: 20%;
    padding: 0 vw(2);
    button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: vw(38);
      border-bottom-right-radius: vw(10);
      border-bottom-left-radius: vw(10);
      box-shadow: 0 0 3px rgba(0, 0, 0, .3);
      color: #555;
      font-weight: bold;
      font-size: vw(11);
      transition: .2s;
      white-space: nowrap;
      &.is-current {
        background: #1e5799;
        background: linear-gradient(to top, #1e5799 0%,#2d7fb4 100%);
        color: #fff;
      }
    }
  }
  @media screen and (min-width: 768px){
    margin-bottom: 24px;
    &__items {
      padding: 0 16px;
    }
    &__item {
      padding: 0 2px;
      button {
        height: 38px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        font-size: 11px
      }
    }
  }
}
/**
 * Button
 */
.button {
  display: flex;
  padding: vw(8) vw(12) vw(8) vw(46);
  li {
    flex: 0 0 50%;
    padding-right: vw(7);
  }
  &__item {
    display: block;
    width: 100%;
    height: vw(36);
    font-weight: bold;
    font-size: vw(11);
    &--clear {
      border: 1px solid;
      color: #0B62A2;
    }
    &--share {
      background: #1e5799;
      background: linear-gradient(to left, #1e5799 0%,#2d7fb4 100%);
      color: #FFF;
    }
  }
  &--vertical {
    display: block;
    padding: 0;
    li {
      padding-right: 0;
      &:not(:first-child) {
        margin-top: vw(16);
      }
    }
  }
  @media screen and (min-width: 768px){
    width: 368px;
    margin: 0 auto;
    padding: 28px 30px;
    li {
      padding-right: 7px;
    }
    &__item {
      height: 36px;
      font-size: 11px;
    }
    &--vertical {
      li {
        &:not(:first-child) {
          margin-top: 32px;
        }
      }
    }
  }
}

/**
 * Preview
 */
.preview {
  position: relative;
  width: 100vw;
  height: vw(252);
  &__item {
    position: absolute;
    img {
      width: 100%;
      height: auto;
    }
    &--shirtsFront {
      top: vw(78);
      left: vw(15);
      width: vw(196);
      > svg, img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
    }
    &--shirtsBack {
      top: vw(144);
      left: vw(182);
      width: vw(108);
      > svg, img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
    }
    &__emblemFront {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 30px;
      min-height: 30px;
      img, svg {
        display: block;
        width: 100%;
      }
    }
    &__emblemBack {
      position: absolute;
      top: 4px;
      right: 6px;
      width: 20px;
      min-height: 20px;
      img, svg {
        display: block;
        width: 100%;
      }
    }
    &__markChestBothSides {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: vw(36);
      left: 50%;
      transform: translateX(-50%);
      width: vw(77);
      height: vw(36);
      background-color: #D9D9D9;
      &.is-selected {
        background-color: transparent;
      }
      img, svg {
        display: block;
        width: 100%;
      }
    }
    &__markChestOneSide {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: vw(36);
      right: vw(60);
      width: vw(26);
      height: vw(26);
      img, svg {
        display: block;
        width: 100%;
      }
    }
    &__markChestNumber {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: vw(72);
      right: vw(60);
      width: vw(26);
      height: vw(16);
      svg {
        display: block;
        width: auto;
        height: 100%;
      }
    }
    &__markBackNumber {
      position: absolute;
      top: vw(28);
      left: 50%;
      transform: translateX(-50%);
      width: vw(24);
      height: vw(24);
      background-color: rgba(#000, .15);
      svg {
        display: block;
        width: auto;
        height: 100%;
        margin: 0 auto;
      }
      &.is-selected {
        background-color: transparent;
      }
    }
    &__markBackName {
      position: absolute;
      top: vw(12);
      left: 50%;
      transform: translateX(-50%);
      width: auto;
      height: vw(8);
      svg {
        display: block;
      }
    }
    &__markSleeveFront {
      position: absolute;
      top: vw(26);
      right: vw(10);
      width: vw(22);
      transform: rotate(-60deg);
      svg {
        display: block;
        width: 100%;
        height: auto;
      }
    }
    &__markSleeveBack {
      position: absolute;
      top: vw(16);
      left: vw(4);
      width: vw(16);
      transform: rotate(60deg);
      svg {
        display: block;
        width: 100%;
        height: auto;
      }
    }
    &__capMark {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: vw(16);
      left: 50%;
      transform: translateX(-50%);
      width: vw(18);
      height: vw(18);
      img, svg {
        display: block;
        height: 100%;
      }
    }
    &--capFront {
      top: vw(4);
      left: vw(44);
      transform: translateX(-16%);
      width: auto;
      height: vw(58);
      svg, img {
        display: block;
      }
      svg {
        position: relative;
        width: auto;
        height: 100%;
      }
      img {
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
    &--capBack {
      top: vw(18);
      left: vw(122);
      width: vw(60);
    }
    &--pants {
      top: vw(4);
      left: vw(292);
      width: vw(62);
      svg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
    }
    &--emblem {
      top: vw(22);
      left: vw(204);
      width: vw(72);
      &:not(.is-selected)::before {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding-top: 100%;
        border-radius: 50%;
        background-color: #D9D9D9;
        content: "";
      }
    }
  }
  @media screen and (min-width: 768px){
    width: 370px;
    height: 240px;
    &__item {
      &--shirtsFront {
        top: 78px;
        left: 15px;
        width: 196px;
      }
      &--shirtsBack {
        top: 144px;
        left: 182px;
        width: 108px;
      }
      &__emblemFront {
        top: 10px;
        left: 10px;
        width: 30px;
        min-height: 30px;
      }
      &__emblemBack {
        top: 4px;
        right: 6px;
        width: 20px;
        min-height: 20px;
      }
      &__markChestBothSides {
        top: 36px;
        width: 77px;
        height: 36px;
      }
      &__markChestOneSide {
        top: 36px;
        right: 60px;
        width: 26px;
        height: 26px;
      }
      &__markChestNumber {
        top: 72px;
        right: 60px;
        width: 26px;
        height: 16px;
      }
      &__markBackNumber {
        top: 28px;
        width: 24px;
        height: 24px;
      }
      &__markBackName {
        top: 12px;
      }
      &__markBackNumber,
      &__markBackName {
        height: 24px;
      }
      &__markSleeveFront {
        top: 26px;
        right: 10px;
        width: 22px;
      }
      &__markSleeveBack {
        top: 16px;
        left: 4px;
        width: 16px;
      }
      &__capMark {
        top: 16px;
        width: 18px;
        height: 18px;
      }
      &--capFront {
        top: 4px;
        left: 44px;
        height: 58px;
      }
      &--capBack {
        top: 18px;
        left: 122px;
        width: 60px;
      }
      &--pants {
        top: 4px;
        left: 292px;
        width: 62px;
      }
      &--emblem {
        top: 22px;
        left: 204px;
        width: 72px;
      }
    }
  }
}

/**
 * Selectors
 */
.selectors {
  padding-bottom: vw(8);
  @media screen and (min-width: 768px){
    padding-bottom: 8px;
  }
}


/**
 * Selector
 */
.selector {
  $selector: #{&};
  position: relative;
  margin: 0 0 0 vw(45);
  &__wrapper {
    overflow: hidden;
    box-shadow: 0 0 4px rgba(0, 0, 0, .16);
  }
  &__container {
    position: relative;
    z-index: 1;
    min-height: vw(208);
    padding: vw(16) 0 vw(16) vw(16);
    background-color: #FFF;
  }
  &__tabs {
    display: flex;
    &__item {
      padding-left: vw(10);
    }
    button {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      top: vw(3);
      width: vw(70);
      height: vw(48);
      padding-top: vw(4);
      border-top-right-radius: vw(10);
      border-top-left-radius: vw(10);
      box-shadow: 0 0 3px rgba(0, 0, 0, .3);
      color: #555;
      font-weight: bold;
      font-size: vw(10);
      transition: .2s;
      &.is-current {
        z-index: 2;
        background: #1e5799;
        background: linear-gradient(to top, #1e5799 0%,#2d7fb4 100%);
        color: #FFF;
      }
    }
    span {
      overflow: hidden;
      width: auto;
      height: vw(20);
      margin-bottom: vw(2);
    }
    svg {
      width: auto;
      height: vw(20);
    }
    &--pants {
      svg {
        width: vw(22);
        height: auto;
      }
    }
  }
  &__subTabs {
    position: absolute;
    top: vw(48);
    right: 100%;
    &__item {
      padding-top: vw(8);
    }
    button {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      left: vw(3);
      width: vw(45);
      height: vw(45);
      border-top-left-radius: vw(10);
      border-bottom-left-radius: vw(10);
      box-shadow: 0 0 3px rgba(0, 0, 0, .3);
      color: #555;
      font-weight: bold;
      font-size: vw(10);
      line-height: 1;
      transition: .2s;
      span {
        display: flex;
        align-items: center;
        overflow: hidden;
        width: auto;
        height: vw(18);
        margin-bottom: vw(4);
      }
      svg {
        width: auto;
        height: auto;
        max-width: 86%;
        max-height: vw(24);
      }
      &.is-selected {
        z-index: 2;
        background: #1e5799;
        background: linear-gradient(to top, #A77E13 0% , #E8B52D 100%);
        color: #FFF;
      }
    }
  }
  @media screen and (min-width: 768px){
    position: relative;
    margin: 22px 0 0 45px;
    &__container {
      min-height: 208px;
      padding: 16px;
    }
    &__tabs {
      display: flex;
      &__item {
        padding-left: 10px;
      }
      button {
        top: 3px;
        width: 70px;
        height: 48px;
        padding-top: 4px;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        font-size: 10px;
      }
      span {
        height: 20px;
        margin-bottom: 2px;
      }
      svg {
        height: 20px;
      }
      &--pants {
        svg {
          width: 22px;
        }
      }
    }
    &__subTabs {
      top: 48px;
      &__item {
        padding-top: 8px;
      }
      button {
        left: 3px;
        width: 45px;
        height: 45px;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        font-size: 10px;
        span {
          height: 18px;
          margin-bottom: 4px;
        }
        svg {
          max-height: 24px;
        }
      }
    }
  }
}

/**
 * items
 */
.items {
  $items: #{&};
  display: flex;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  &:not(:first-child) {
    margin-top: vw(14);
  }
  &__item {
    width: vw(47);
    padding-bottom: 2px;
    margin-right: vw(8);
  }
  &__button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: vw(47);
    height: vw(47);
    border: 1px solid rgba(#000, .2);
    border-radius: vw(5);
    color: #555;
    font-weight: bold;
    font-size: vw(10);
    line-height: 1;
    &.is-selected {
      border-color: rgba(#000, .5);
    }
  }
  &__thumb {
    svg, img {
      display: block;
      width: vw(30);
      height: auto;
    }
  }
  &__name {
    margin-top: vw(4);
  }
  &--shirtsItems {
    #{$items}__item {
      width: vw(68);
      margin-right: vw(8);
    }
    #{$items}__button {
      width: vw(68);
      height: vw(68);
      white-space: nowrap;
    }
    #{$items}__thumb {
      overflow: hidden;
      width: vw(65);
      margin-bottom: vw(4);
      svg, img {
        width: vw(48);
        margin: 0 auto;
      }
    }
  }
  &--capElements {
    #{$items}__item {
      width: vw(68);
      margin-right: vw(8);
    }
    #{$items}__button {
      width: vw(68);
      height: vw(68);
    }
    #{$items}__thumb {
      overflow: hidden;
      width: vw(38);
      height: auto;
      margin-bottom: vw(4);
      svg, img {
        width: 100%;
      }
    }
  }
  &--markElements {
    #{$items}__item {
      width: vw(68);
      margin-right: vw(8);
    }
    #{$items}__button {
      width: vw(68);
      height: vw(68);
    }
    #{$items}__thumb {
      overflow: hidden;
      width: vw(65);
      height: vw(32);
      margin-bottom: vw(4);
      svg, img {
        width: auto;
        height: 100%;
        margin: 0 auto;
      }
    }
  }
  &--markChestNumberItems,
  &--markBackNumberItems {
    #{$items}__thumb {
      overflow: hidden;
      width: vw(12);
      svg, img {
        width: 100%;
      }
    }
  }
  &--markBackNameItems,
  &--markSleeveJapaneseItems,
  &--markSleeveEnglishItems {
    #{$items}__thumb {
      overflow: hidden;
      width: 84%;
      svg, img {
        width: 100%;
      }
    }
  }
  &--markOneSideItems {
    #{$items}__thumb {
      overflow: hidden;
      svg, img {
        width: 100%;
      }
    }
  }
  &--pantsElements {
    #{$items}__item {
      width: vw(68);
      margin-right: vw(8);
    }
    #{$items}__button {
      width: vw(68);
      height: vw(68);
    }
    #{$items}__thumb {
      overflow: hidden;
      width: vw(32);
      height: vw(28);
      margin-bottom: vw(8);
      svg, img {
        width: 100%;
      }
    }
  }
  &--pantsItems {
    #{$items}__thumb {
      overflow: hidden;
      width: vw(28);
      margin-top: vw(12);
      svg, img {
        width: 100%;
      }
    }
  }
  &--emblemCategories {
    #{$items}__item {
      width: vw(68);
    }
    #{$items}__button {
      width: vw(68);
      height: vw(68);
    }
    #{$items}__thumb {
      svg, img {
        width: vw(39);
      }
    }
  }
  &--textures {
     #{$items}__button {
       overflow: hidden;
       img {
         object-fit: contain;
       }
     }
  }
  &--colors {
    margin: 0 0 0 vw(-16);
    padding: 0 0 0 vw(16);
    #{$items}__item {
      width: vw(30);
    }
    #{$items}__button {
      display: block;
      width: vw(30);
      height: vw(30);
      border-radius: 50%;
      &.is-none {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        color: #555;
        font-size: vw(10);
        &::before {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%); 
          width: 92%;
          height: 92%;
          border: 1px solid rgba(#000, .2);
          border-radius: 50%;
          content: "";
        }
        span {
          transform: scale(.85);
        }
      }
      &.is-selected.is-none::before {
        border-color: rgba(#000, .5);
      }
    }
  }
  @media screen and (min-width: 768px){
    margin: 0 0 0 -16px;
    padding: 0 0 0 16px;
    &:not(:first-child) {
      margin-top: 14px;
    }
    &__item {
      width: 47px;
      margin-right: 8px;
    }
    &__button {
      width: 47px;
      height: 47px;
      border-radius: 5px;
      font-size: 10px;
    }
    &__thumb {
      svg, img {
        width: 30px;
      }
    }
    &__name {
      margin-top: 4px;
    }
    &--shirtsItems {
      #{$items}__item {
        width: 68px;
        margin-right: 8px;
      }
      #{$items}__button {
        width: 68px;
        height: 68px;
      }
      #{$items}__thumb {
        width: 65px;
        margin-bottom: 4px;
        svg, img {
          width: 48px;
        }
      }
    }
    &--capElements {
      #{$items}__item {
        width: 68px;
        margin-right: 8px;
      }
      #{$items}__button {
        width: 68px;
        height: 68px;
      }
      #{$items}__thumb {
        width: 38px;
        margin-bottom: 4px;
      }
    }
    &--markElements {
      #{$items}__item {
        width: 68px;
        margin-right: 8px;
      }
      #{$items}__button {
        width: 68px;
        height: 68px;
      }
      #{$items}__thumb {
        width: 65px;
        height: 32px;
        margin-bottom: 4px;
      }
    }
    &--markChestNumberItems,
    &--markBackNumberItems {
      #{$items}__thumb {
        width: 12px;
      }
    }
    &--pantsElements {
      #{$items}__item {
        width: 68px;
        margin-right: 8px;
      }
      #{$items}__button {
        width: 68px;
        height: 68px;
      }
      #{$items}__thumb {
        width: 32px;
        height: 28px;
        margin-bottom: 8px;
      }
    }
    &--pantsItems {
      #{$items}__thumb {
        width: 28px;
        margin-top: 12px;
      }
    }
    &--emblemCategories {
      #{$items}__item {
        width: 68px;
      }
      #{$items}__button {
        width: 68px;
        height: 68px;
      }
      #{$items}__thumb {
        svg, img {
          width: 39px;
        }
      }
    }
    &--colors {
      #{$items}__item {
        width: 30px;
      }
      #{$items}__button {
        width: 30px;
        height: 30px;
        &.is-none {
          font-size: 10px;
        }
      }
    }
  }
}

/**
 * modal
 */
.modal {
  $root: #{&};
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: 30px;
  background: rgba(0, 0, 0, .6);
  &__body {
    position: relative;
    width: 100%;
  }
  &__content {
    overflow-y: scroll;
    max-height: 92vh;
    padding: vw(32) vw(24);
    border-radius: vw(16);
    background-color: #FFF;
  }
  @media screen and (min-width: 768px){
    &__body {
      max-width: 802px;
      margin: 0 auto;
    }
    &__content {
      padding: 32px 24px;
      border-radius: 16px;
    }
  }
}
.modal-enter-active,
.modal-leave-active {
  transition: opacity .2s;
  .modal__body {
    transition: opacity .2s, transform .2s;
  }
}
.modal-leave-active {
  transition: opacity .4s ease .2s;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
  .modal__body {
    opacity: 0;
    transform: translateY( -30px );
  }
}

/**
 * SelectorSection
 */
.selectorSection {
  margin-top: vw(14);
  &__name {
    padding: 0 vw(10);
    border-radius: vw(5);
    background-color: rgba(#555, .3);
    color: #fff;
    font-weight: bold;
    font-size: vw(10);
    line-height: 1.5;
  }
  @media screen and (min-width: 768px){
    margin-top: 14px;
    &__name {
      padding: 0 10px;
      border-radius: 5px;
      font-size: 10px;
    }
  }
}
</style>
